import ApiService from '@services/api.service';

const inFlightSends = new Map();

export const conversationUser = {
  namespaced: true,

  state: {
    conversation: null,
    conversations: [],
    messages: [],
  },

  mutations: {
    setConversation(state, conversation) {
      state.conversation = conversation;
    },
    setConversations(state, conversations) {
      state.conversations = conversations;
    },
    setMessages(state, messages) {
      state.messages = messages;
    },
    appendMessage(state, message) {
      if (message?.id && state.messages.some((msg) => msg.id === message.id)) {
        return;
      }
      state.messages.push(message);
    },
  },

  actions: {
    /**
     * Initialise ou récupère la conversation liée à un entretien.
     * POST conversation_formateur_init
     */
    async initConversation({ commit }, { interviewId, stagiaireId, suiviId }) {
      try {
        const payload = suiviId
          ? { suiviId }
          : { interviewId, stagiaireId };
        const resp = await ApiService.postRequest('conversation_formateur_init', payload, true);
        commit('setConversation', resp.data);
        return resp.data;
      } catch (err) {
        console.error('Erreur init conversation:', err);
        throw err;
      }
    },

    async initSuiviEntrepriseConversation({ dispatch }, suiviId) {
      return dispatch('initConversation', { suiviId });
    },

    /**
     * Charge tous les messages d'une conversation.
     * GET /conversation_formateur_detail/{id}
     */
    async loadConversationDetail({ commit }, conversationId) {
      try {
        const resp = await ApiService.getRequest(`/conversation_formateur_detail/${conversationId}`, {}, true);
        commit('setMessages', resp.data.messages || []);
        return resp.data;
      } catch (err) {
        console.error('Erreur chargement messages:', err);
        throw err;
      }
    },

    /**
     * Envoie un message dans une conversation.
     * POST /conversation_formateur_message/{id}
     */
    async sendMessage({ commit }, { conversationId, content, formData }) {
      try {
        const payload = formData || (() => {
          const fd = new FormData()
          if (content) fd.append('content', content)
          return fd
        })()

        const text = (payload.get && payload.get('content')) || content || ''
        const sendKey = `${conversationId}:${text}`
        if (inFlightSends.has(sendKey)) {
          return inFlightSends.get(sendKey)
        }

        const request = ApiService.postRequest(
          `/conversation_formateur_message/${conversationId}`,
          payload,
          true
        ).then((resp) => {
          commit('appendMessage', resp.data)
          return resp.data
        }).finally(() => {
          setTimeout(() => inFlightSends.delete(sendKey), 1500)
        })

        inFlightSends.set(sendKey, request)
        return request
      } catch (err) {
        console.error('Erreur envoi message:', err)
        throw err
      }
    },

    /**Télécharge le document lié à la comunication **/
    async downloadAttachment({ commit }, pj) {
      try {
        const resp = await ApiService.getRequest(
          `/conversation_formateur_attachment/${pj.id}`,
          { responseType: 'blob' }
        )
        const blob = new Blob([resp.data], { type: pj.mimeType })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', pj.originalFileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        setTimeout(() => window.URL.revokeObjectURL(url), 1000)
      } catch (err) {
        console.error('Erreur téléchargement pièce jointe:', err)
        throw err
      }
    },

    /**
     * Marque une conversation comme lue.
     * PATCH /conversation_formateur_read/{id}
     */
    async markAsRead({ commit }, conversationId) {
      try {
        await ApiService.patchRequest(`/conversation_formateur_read/${conversationId}`, {}, null, true);
      } catch (err) {
        console.error('Erreur mark as read:', err);
      }
    },
  },

  getters: {
    getConversation: (state) => state.conversation,
    getConversations: (state) => state.conversations,
    getMessages: (state) => state.messages,
  },
};
